module.exports = __webpack_public_path__ + "img/paul_24.848e0d98.jpg";